@if ((corporateTaxEntity$ | async) && (vpbBerekening$ | async)) {
  <form [formGroup]="balansEnResultatenRekeningFg" style="max-width: 90%">

    <div style="min-width: 308px;"></div>
    <div class="row">
      <div class="col">
      </div>
      <div class="col-1">
        <p>Kostprijs / <br/>nominale waarde</p>
      </div>
      <div class="col-2">
        <p><b>{{ labelBalansSlot }}</b></p>
      </div>
      <div class="col-3">
        <p><b>{{ labelBalansOpening }}</b></p>
      </div>
    </div>

    <div class="row">
      <div class="col col-1" style="min-width: 308px">
        <p>Goodwill</p>
      </div>
      <div class="col-2" formArrayName="goodwill">
        @for (item of getArrayControls('goodwill'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="nominaleWaardeOfKostenprijs"
                                              id="nominaleWaardeOfKostenprijs">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="goodwill">
        @for (item of getArrayControls('goodwill'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="goodwill1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="goodwill">
        @for (item of getArrayControls('goodwill'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="goodwill2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Overige immateriële vaste activa</p>
      </div>
      <div class="col-2" formArrayName="overigeImmaterieleActiva">
        @for (item of getArrayControls('overigeImmaterieleActiva'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="nominaleWaardeOfKostenprijs"
                                              id="nominaleWaardeOfKostenprijs1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="overigeImmaterieleActiva">
        @for (item of getArrayControls('overigeImmaterieleActiva'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="overigeImmaterieleActiva1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="overigeImmaterieleActiva">
        @for (item of getArrayControls('overigeImmaterieleActiva'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="overigeImmaterieleActiva2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Gebouwen en terreinen</p>
      </div>
      <div class="col-2">
        <snelstart-venture-fiscaal-feature-spec-gebouwen></snelstart-venture-fiscaal-feature-spec-gebouwen>
      </div>
      <div class="col-3" formArrayName="gebouwenEnTerreinen">
        @for (item of getArrayControls('gebouwenEnTerreinen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="gebouwenEnTerreinen1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="gebouwenEnTerreinen">
        @for (item of getArrayControls('gebouwenEnTerreinen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="gebouwenEnTerreinen2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Machines en installaties</p>
      </div>
      <div class="col-2">
        <snelstart-venture-fiscaal-feature-spec-machines-en-installaties></snelstart-venture-fiscaal-feature-spec-machines-en-installaties>
      </div>
      <div class="col-3" formArrayName="machinesEnInstallaties">
        @for (item of getArrayControls('machinesEnInstallaties'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="machinesEnInstallaties1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="machinesEnInstallaties">
        @for (item of getArrayControls('machinesEnInstallaties'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="machinesEnInstallaties2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Andere vaste activa</p>
      </div>
      <div class="col-2">
        <snelstart-venture-fiscaal-feature-spec-andere-vaste-activa></snelstart-venture-fiscaal-feature-spec-andere-vaste-activa>
      </div>
      <div class="col-3" formArrayName="andereVasteActiva">
        @for (item of getArrayControls('andereVasteActiva'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="andereVasteActiva1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="andereVasteActiva">
        @for (item of getArrayControls('andereVasteActiva'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="andereVasteActiva2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5 pt-3">
      <div class="col col-1" style="min-width: 308px">
        <p>Langlopende vord. groepsmaatschappijen</p>
      </div>
      <div class="col-2" formArrayName="vorderingenLangGroepsmaatschappijen">
        @for (item of getArrayControls('vorderingenLangGroepsmaatschappijen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="nominaleWaardeOfKostenprijs"
                                              id="nominaleWaardeOfKostenprijs3">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="vorderingenLangGroepsmaatschappijen">
        @for (item of getArrayControls('vorderingenLangGroepsmaatschappijen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="vorderingenLangGroepsmaatschappijen1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="vorderingenLangGroepsmaatschappijen">
        @for (item of getArrayControls('vorderingenLangGroepsmaatschappijen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="vorderingenLangGroepsmaatschappijen2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Langlopende vord. participanten</p>
      </div>
      <div class="col-2" formArrayName="vorderingenLangParticipanten">
        @for (item of getArrayControls('vorderingenLangParticipanten'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="nominaleWaardeOfKostenprijs"
                                              id="nominaleWaardeOfKostenprijs4">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="vorderingenLangParticipanten">
        @for (item of getArrayControls('vorderingenLangParticipanten'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="vorderingenLangParticipanten1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="vorderingenLangParticipanten">
        @for (item of getArrayControls('vorderingenLangParticipanten'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="vorderingenLangParticipanten2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Overige financiele vaste activa</p>
      </div>
      <div class="col-2" formArrayName="overigeFinancieelVasteActiva">
        @for (item of getArrayControls('overigeFinancieelVasteActiva'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="nominaleWaardeOfKostenprijs"
                                              id="nominaleWaardeOfKostenprijs5">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="overigeFinancieelVasteActiva">
        @for (item of getArrayControls('overigeFinancieelVasteActiva'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="overigeFinancieelVasteActiva1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="overigeFinancieelVasteActiva">
        @for (item of getArrayControls('overigeFinancieelVasteActiva'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="overigeFinancieelVasteActiva2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Deelnemingen</p>
      </div>
      <div class="col-2" formArrayName="deelnemingen">
        @for (item of getArrayControls('deelnemingen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="deelnemingen1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="deelnemingen">
        @for (item of getArrayControls('deelnemingen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="deelnemingen2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5 pt-3">
      <div class="col col-1" style="min-width: 308px">
        <p>Voorraden</p>
      </div>
      <div class="col-2" formArrayName="voorraden">
        @for (item of getArrayControls('voorraden'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="voorraden1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="voorraden">
        @for (item of getArrayControls('voorraden'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="voorraden2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Onderhanden werk</p>
      </div>
      <div class="col-2" formArrayName="onderhandenWerk">
        @for (item of getArrayControls('onderhandenWerk'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="onderhandenWerk1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="onderhandenWerk">
        @for (item of getArrayControls('onderhandenWerk'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="onderhandenWerk2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Debiteuren</p>
      </div>
      <div class="col-2" formArrayName="vorderingDebiteuren">
        @for (item of getArrayControls('vorderingDebiteuren'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="nominaleWaardeOfKostenprijs"
                                              id="nominaleWaardeOfKostenprijs6">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="vorderingDebiteuren">
        @for (item of getArrayControls('vorderingDebiteuren'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="vorderingDebiteuren1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="vorderingDebiteuren">
        @for (item of getArrayControls('vorderingDebiteuren'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="vorderingDebiteuren2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Omzetbelasting</p>
      </div>
      <div class="col-2" formArrayName="vorderingenOmzetbelasting">
        <snelstart-venture-fiscaal-feature-spec-omzetbelasting></snelstart-venture-fiscaal-feature-spec-omzetbelasting>
      </div>
      <div class="col-3" formArrayName="vorderingenOmzetbelasting">
        @for (item of getArrayControls('vorderingenOmzetbelasting'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="vorderingenOmzetbelasting1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="vorderingenOmzetbelasting">
        @for (item of getArrayControls('vorderingenOmzetbelasting'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="vorderingenOmzetbelasting2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Kortlopende vorderingen groepsmaatschappijen</p>
      </div>
      <div class="col-2" formArrayName="vorderingenKortGroepsmaatschappijen">
        @for (item of getArrayControls('vorderingenKortGroepsmaatschappijen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="nominaleWaardeOfKostenprijs"
                                              id="nominaleWaardeOfKostenprijs7">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="vorderingenKortGroepsmaatschappijen">
        @for (item of getArrayControls('vorderingenKortGroepsmaatschappijen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="vorderingenKortGroepsmaatschappijen1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="vorderingenKortGroepsmaatschappijen">
        @for (item of getArrayControls('vorderingenKortGroepsmaatschappijen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="vorderingenKortGroepsmaatschappijen2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Kortlopende vorderingen participanten</p>
      </div>
      <div class="col-2" formArrayName="vorderingenKortParticipanten">
        @for (item of getArrayControls('vorderingenKortParticipanten'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="nominaleWaardeOfKostenprijs"
                                              id="nominaleWaardeOfKostenprijs8">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="vorderingenKortParticipanten">
        @for (item of getArrayControls('vorderingenKortParticipanten'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="vorderingenKortParticipanten1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="vorderingenKortParticipanten">
        @for (item of getArrayControls('vorderingenKortParticipanten'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="vorderingenKortParticipanten2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Overige kortlopende vorderingen</p>
      </div>
      <div class="col-2" formArrayName="vorderingenOverig">
        @for (item of getArrayControls('vorderingenOverig'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="nominaleWaardeOfKostenprijs"
                                              id="nominaleWaardeOfKostenprijs9">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="vorderingenOverig">
        @for (item of getArrayControls('vorderingenOverig'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="vorderingenOverig1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="vorderingenOverig">
        @for (item of getArrayControls('vorderingenOverig'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="vorderingenOverig2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5 pt-3">
      <div class="col col-1" style="min-width: 308px">
        <p>Effecten</p>
      </div>
      <div class="col-2" formArrayName="effecten">
        @for (item of getArrayControls('effecten'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="effecten1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="effecten">
        @for (item of getArrayControls('effecten'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="effecten2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Liquide middelen</p>
      </div>
      <div class="col-2" formArrayName="liquideMiddelen">
        @for (item of getArrayControls('liquideMiddelen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="slotbalans"
                                              id="liquideMiddelen1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="liquideMiddelen">
        @for (item of getArrayControls('liquideMiddelen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="openingsbalans"
                                              id="liquideMiddelen2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>
  </form>

  <form [formGroup]="berekendeActivaFg" style="max-width: 90%">
    <div class="row mb-0.5 pt-3">
      <div class="col col-1" style="min-width: 308px">
        <p><b>Totaal activa</b></p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control [disabledControl]="true"
                                          [prefix]="'€'"
                                          [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="totaalActivaFiscaalEind"
                                          id="totaal1">
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control [disabledControl]="true"
                                          [prefix]="'€'"
                                          [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="totaalActivaFiscaalBegin"
                                          id="totaal2">
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
}
